<script>

import moduleUtils from '../ModuleUtils';
import SgsRender from 'src/components/utils/sgs/SgsRender.vue';
import SgsRenderCollapse from 'src/components/utils/sgs/SgsRenderCollapse.vue';
import SgsRenderNotificationSuccess from 'src/components/utils/sgs/SgsRenderNotificationSuccess.vue';
import SgsRenderNotificationError from 'src/components/utils/sgs/SgsRenderNotificationError.vue';
import utils from '../FormBuilderUtils.js';
import {mapActions} from 'vuex';

export default {
  props: [
    'rows', 'fields', 'formIdentifier',
    'id', 'parentId', 'parentColumnName',
    'title', 'showEditButton', 'showDeleteButton',
    'showCreateButton', 'businessRulesBeforeCrudViewShow'
  ],
  components: {
    SgsRender,
    SgsRenderCollapse,
    SgsRenderNotificationSuccess,
    SgsRenderNotificationError
  },
  data () {
    return {
      instance: {},
      rowsToShow: [],
      notificationError: null,
      notificationSuccess: null
    }
  },
  methods: {
    ...mapActions([
      'showLoader',
      'hideLoader'
    ]),
    back: function () {
      this.$emit('changeModuleActive', 'list');
    },
    edit: function () {
      this.$emit('changeModuleActive', 'form', this.id);
    },
    create: function() {
      this.$emit('changeModuleActive', 'form');
    },
    getField: function(id) {
      return utils.findField(id, this.fields);
    },
    getFieldValue: function(id) {

      var el = this.getField(id)
      if (el == undefined) {
        return "not found TODO";
      }

      return this.instance[el.columnName];
    },
    doDelete: function() {

      this.$confirm(this.$t('confirmTheDeletion'), this.$t('warning'), {
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no'),
        type: 'warning'
      }).then(() => {

        this.showLoader();

        moduleUtils.moduleFormRowDelete(this.formIdentifier, this.id).then(response => {

          this.hideLoader();

          this.notificationError = response.body.notificationError;
          this.notificationSuccess = response.body.notificationSuccess;

          if (response.meta.code == 200) {

            this.$notify({
              title: this.$t('success'),
              message: this.$t('itemDeleted'),
              type: 'success'
            });

            this.back();

          } else if (response.meta.code == 400) {

            this.$alert(
              response.body.error.message,
              'Erro',
              {
                confirmButtonText: this.$t('close'),
                type: 'error'
              }
            );
          } else {
            console.log("error on delete: ", response);
          }
        });
      });
    },
    callBusinessRule: function(businessRuleId) {

      this.showLoader();

      moduleUtils.callBusinessRule(this.formIdentifier, this.instance, businessRuleId)
        .then(response => {

          this.hideLoader();

          _.forOwn(response.body.instance, (value, key) => {
            this.$set(this.instance, key, value);
          });

          this.notificationError = response.body.notificationError;
          this.notificationSuccess = response.body.notificationSuccess;
        })
    },
    actionLinkSelected: function(formId, dataRow) {
      this.$emit('actionLinkSelected', formId, dataRow);
    }
  },
  mounted() {

    if (this.rows !== undefined && this.fields !== undefined) {

      let collapseField = null;

      this.rows.map(row => {

        let newRow = {"cols": []};
        let eARowDoCollapse = false;

        row.cols.map(col => {

          if(col.fields.length > 0) {

            let newCol = {
              "width": col.width,
              "fields": []
            }

            col.fields.map(field => {

              let fieldFound = this.getField(field.id);

              if (fieldFound.id) {

                newCol.fields.push(fieldFound);

                if (fieldFound.type == 'collapse') {
                  eARowDoCollapse = true;
                  collapseField = fieldFound;
                  collapseField.rows = [];
                }
              }
            });

            if (newCol.fields.length > 0) {
              newRow.cols.push(newCol);
            }
          }
        });

        if (newRow.cols.length > 0) {

          if (collapseField) {

            if (eARowDoCollapse) {
              this.rowsToShow.push(newRow);
            } else {
              collapseField.rows.push(newRow);
            }

          } else {
            this.rowsToShow.push(newRow);
          }

        } else {
          collapseField = null;
        }
      });
    }

    this.fields.map(it => {
      if (it.columnName && it.type !== 'dashboard') {
        this.$set(this.instance, it.columnName, "")
      }
    });

    moduleUtils.resolveFormDataRow(this.formIdentifier, this.id, "show")
      .then(response => {
        _.forOwn(response.data.body.instance, (value, key) => {
          this.$set(this.instance, key, value);
        });
      }).then(() => {
        if(this.businessRulesBeforeCrudViewShow) {
          this.callBusinessRule(this.businessRulesBeforeCrudViewShow);
        }
      });
  }
}
</script>

<template>
  <div>

    <SgsRenderNotificationSuccess v-model="notificationSuccess"/>
    <SgsRenderNotificationError v-model="notificationError"/>

    <div class="page-header">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <h2>{{ title }}</h2>
        </div>

        <div class="col-sm-12 col-md-6" style="margin-top: 11px;">
          <div class="pull-right">
            <el-button-group>
              <el-button
                type="primary"
                size="small"
                @click.prevent="edit()"
                v-if="showEditButton"
                id="edit">
                <i class="glyphicon glyphicon-edit" aria-hidden="true" />
                {{$t('edit')}}
              </el-button>
              <el-button size="small" type="primary" @click.prevent="create()" v-if="showCreateButton">
                <i class="glyphicon glyphicon-plus" aria-hidden="true"/>
                {{$t('newA')}} {{ title }}
              </el-button>
              <el-button
                type="danger"
                size="small"
                v-if="showDeleteButton"
                @click="doDelete()"
                id="edit">
                <i class="glyphicon glyphicon-trash" aria-hidden="true" />
                {{$t('delete')}}
              </el-button>
              <el-button
                size="small"
                @click.prevent="back()"
                id="backToSearch">
                <i class="glyphicon glyphicon-chevron-left" aria-hidden="true" />
                {{$t('backToList')}}
              </el-button>
            </el-button-group>
          </div>
        </div>
      </div>
    </div>

    <div class="panel">
      <div class="panel-body">

        <div class="row details" v-for="(row, index) in rowsToShow">

          <div v-for="(col, index) in row.cols" :class="'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width">
            <template v-for="field in col.fields">
              <SgsRender
                v-if="field.type != 'collapse'"
                moduleType="show"
                :type="field.type"
                :attr="field"
                labelOnly="true"
                :fieldValue="instance[field.columnName]"
                :formIdentifier="formIdentifier"
                @callBusinessRule="callBusinessRule"
                @actionLinkSelected="actionLinkSelected"
                :instance="instance"
              >
              </SgsRender>

              <SgsRenderCollapse v-else :attr="field" moduleType="show">

                <div class="row" v-for="row in field.rows">

                  <div v-for="col in row.cols" :class="'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width">

                    <template v-for="field in col.fields">

                      <SgsRender
                        v-if="field.type != 'collapse'"
                        moduleType="show"
                        :type="field.type"
                        :attr="field"
                        labelOnly="true"
                        :fieldValue="instance[field.columnName]"
                        :formIdentifier="formIdentifier"
                        @callBusinessRule="callBusinessRule"
                        @actionLinkSelected="actionLinkSelected"
                      />

                    </template>
                  </div>
                </div>
              </SgsRenderCollapse>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  div.details label {
    font-weight: 600;
    margin-bottom: 7px;
  }

  div.details span {
    color: #333;
    font-size: 13px;
    font-weight: 200;
    line-height: 23px;
    min-height: 23px;
    margin-bottom: 7px;
  }
  div.details {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// ModuleShow.vue?05e2264c